import { Box, Dialog, DialogContent, DialogTitle, Grid, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { headingBlue, maroon, red } from '../../assets/colors'
import { getWORKerHeadsDetails } from '../../backend/backendApis'
import { Navigate, useNavigate } from 'react-router-dom'
import HttpService from '../../backend/requestApis'
import Loader from '../Loader'

const WORKersHeadsDiaog = (props) => {

  const navigate = useNavigate()

  const [headDetailsError, setHeadDetailsError] = useState(null)
  const [headDetails, setHeadDetails] = useState([])
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    setHeadDetails([])
    setHeadDetailsError(null)
    setLoader(false)
  }, [props.dialogStatus])

  useEffect(() => {
    try{
      setLoader(true)
      let contactNumber = localStorage.getItem('contact')
      if(contactNumber){
        if( props.dialogStatus){
          let options = {
            url: getWORKerHeadsDetails,
            method: 'GET',
            params: {
              contactNumber: contactNumber
            },
            headers: {
              authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
            }
          }

          HttpService(options).then((resp) => {
            setHeadDetails(resp?.data?.data)
            setLoader(false)
          }).catch(err => {
            if(err?.status === 403){
              localStorage.clear()
              setLoader(false)
              navigate('/signUp')
            } else {
              console.log("Error in fetching the WORKer's head Details: ", err)
              setHeadDetailsError('Error in fetching the Heads. Please contact support.')
              setLoader(false)
            }
          })
        }
      } else {
        setLoader(false)
        localStorage.clear()
        navigate('/signUp')
      }

    } catch(err){
      console.log('Error in fetching head Details: ', err)
      setHeadDetailsError('Error in fetching the Heads. Please contact support.')
      setLoader(false)
    }
  }, [props.dialogStatus])
  
  var titleStyle={
    backgroundColor: headingBlue,
    color: 'white',
    fontSize:'1rem',
    display: "flex",
    alignItems: 'center'
  }

  return (
    <>
        <Dialog maxWidth= 'xs' fullWidth open={props.dialogStatus} onClose={() => props.updateDialog(false)}>
            <DialogTitle sx={{height: "1.8rem", padding: "0.4rem 0rem 0.4rem 1rem"  }}  style={titleStyle}>
              Heads
            </DialogTitle>
            <DialogContent style={{marginTop: 1}}>
              <>
                {loader && <Loader></Loader>}

                <Paper style={{marginTop: '1rem', padding: '0.5rem 0.3rem 0.5rem 0.3rem', color: headingBlue}}>
                  <Typography>District Head</Typography>
                  {headDetails['districtHead'] ?
                    <Grid container spacing={1} style={{color: maroon}}>
                      <Grid item xs={6} sm={4}>
                        {headDetails['districtHead']}
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        {headDetails['districtHeadCN']}
                      </Grid>

                    </Grid> :
                    !(loader) && !(headDetailsError) ?
                    <Typography style={{padding: '1rem 0.5rem 1rem 0.5rem', color: maroon}}>
                      Not yet assigned.
                    </Typography> :
                    <></>
                    
                  }
                  
                </Paper>

                <Paper style={{marginTop: '1rem', padding: '0.5rem 0.3rem 0.5rem 0.3rem', color: headingBlue}}>
                  <Typography>State Head</Typography>
                  {headDetails['stateHead'] ?
                    <Grid container spacing={1} style={{color: maroon}}>
                      <Grid item xs={6} sm={4}>
                        {headDetails['stateHead']}
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        {headDetails['stateHeadCN']}
                      </Grid>

                    </Grid> :
                    !(loader) && !(headDetailsError) ?
                    <Typography style={{padding: '1rem 0.5rem 1rem 0.5rem', color: maroon}}>
                      Not yet assigned.
                    </Typography> :
                    <></> 
                  }
                  
                </Paper>
                <Box style={{display: 'flex', justifyContent: 'center'}}>
                <Typography style={{color: red, fontSize: '0.9rem', padding: '1rem 0.4rem 0rem 0.4rem'}}>{headDetailsError}</Typography>
                </Box>
                
              </>

            </DialogContent>

        </Dialog>
    </>
  )
}

export default WORKersHeadsDiaog